import { useEffect, useState } from 'react';

export type Theme = 'light' | 'dark';
const KEY = 'replya_theme';

export function getStoredTheme(): Theme {
  if (typeof window === 'undefined') return 'light';
  const v = window.localStorage.getItem(KEY);
  return v === 'dark' ? 'dark' : 'light';
}

export function applyTheme(theme: Theme) {
  if (typeof document === 'undefined') return;
  const root = document.documentElement;
  if (theme === 'dark') root.classList.add('dark');
  else root.classList.remove('dark');
}

export function setStoredTheme(theme: Theme) {
  if (typeof window !== 'undefined') window.localStorage.setItem(KEY, theme);
  applyTheme(theme);
}

export function useTheme() {
  const [theme, setTheme] = useState<Theme>(() => {
    const t = getStoredTheme();
    applyTheme(t);
    return t;
  });

  useEffect(() => {
    applyTheme(theme);
  }, [theme]);

  const toggle = () => {
    const next: Theme = theme === 'dark' ? 'light' : 'dark';
    setTheme(next);
    setStoredTheme(next);
  };

  return {
    theme,
    toggle,
    setTheme: (t: Theme) => {
      setTheme(t);
      setStoredTheme(t);
    },
  };
}
